import { ConcreteEncodable } from "./ConcreteEncodable";

import { PlRequestOrderTypeStrategyImplEncoder } from "../../encoder/PlRequestOrderTypeStrategyImplEncoder";

import * as CubiqTS from "../../index";
import { PlRequestOrderTypeStrategy } from "../PlRequestOrderTypeStrategy";

export class PlRequestOrderTypeStrategyImpl
  extends ConcreteEncodable
  implements PlRequestOrderTypeStrategy
{
  public static enType: string = "com.bcdfx.model.PlRequestOrderTypeStrategyImpl";

  /*FID=1*/
  public id: CubiqTS.RequestOrderType;
  /*FID=2*/
  public description: string;
  /*FID=3*/
  public isCreditCheckAllowedFg: boolean;
  /*FID=4*/
  public isMarkupAllowedFg: boolean;
  /*FID=5*/
  public isSTPAggregatedFg: boolean;
  /*FID=6*/
  public isSTPAggPartFillsFg: boolean;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = PlRequestOrderTypeStrategyImplEncoder.Instance;
    this.setEncodableType(PlRequestOrderTypeStrategyImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "PlRequestOrderTypeStrategyImpl[" +
      "id=" +
      this.id +
      "description=" +
      this.description +
      "isCreditCheckAllowedFg=" +
      this.isCreditCheckAllowedFg +
      "isMarkupAllowedFg=" +
      this.isMarkupAllowedFg +
      "isSTPAggregatedFg=" +
      this.isSTPAggregatedFg +
      "isSTPAggPartFillsFg=" +
      this.isSTPAggPartFillsFg +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
